var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentNotifications.length > 0
    ? _c(
        "v-list",
        {
          staticClass: "notifications-overlay",
          attrs: {
            "two-line": "",
            fixed: "",
            right: "",
            bottom: "",
            color: "transparent",
            role: "status",
            "aria-live": "polite",
          },
        },
        _vm._l(_vm.currentNotifications, function (notification) {
          return _c(
            "v-list-item",
            _vm._b(
              {
                key: notification.id,
                class: [notification.color, "notifications-overlay-list-item"],
                attrs: { "full-width": "", dense: "", link: "" },
              },
              "v-list-item",
              notification.navigateTo,
              false
            ),
            [
              _c(
                "v-list-item-avatar",
                { attrs: { size: "25" } },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color: notification.iconColor,
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s("fad fa-" + notification.icon) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  notification.message
                    ? _c("v-list-item-title", {
                        domProps: { textContent: _vm._s(notification.message) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  notification.date
                    ? _c("v-list-item-subtitle", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.toReadableDate(notification.date)
                          ),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }